<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapnum"><a id="one"></a><span class="small">PART ONE</span></h1>
<h1 class="chaptitle">UFOs</h1>
<p class="blockquotetext"><i>Pure logical thinking cannot yield us any knowledge of the empirical world; all knowledge of reality starts from experience and ends in it.</i></p>
<p class="right"><b>—Albert Einstein</b></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_partone.vue?b39ff06c